module.exports = __webpack_public_path__ + "static/agent_gif-7d691b3e58d06b8b877758cafb443152.gif";